import {
  ProbationDecisionOutcome,
  type ReviewAnswer,
  type ReviewQuestion,
} from '@gokrew/models/performance';

/**
 * The chosen option of a probation decision question means "extend", so the
 * answer needs its `date` (v2 spec V2-5). Shared by the renderer and each
 * portal's required-answer check.
 */
export const isExtensionChoice = (
  question: ReviewQuestion,
  answer?: Pick<ReviewAnswer, 'optionId'> | null
): boolean =>
  !!question.probationDecision &&
  (question.options ?? []).find((o) => o.id === answer?.optionId)
    ?.probationOutcome === ProbationDecisionOutcome.EXTEND;
